import React from 'react'

import { Backdrop } from '../../../Backdrop'
import { ModalHeader } from './ModalHeader'
import { Content, Inner } from './styles'

interface PassedBackdropProps {
  open?: boolean
  zIndex?: number
  children?: React.ReactNode
  onClick?: () => void
  onClosed?: () => void
}

export interface InternalModalProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Modal title
   */
  title?: React.ReactNode

  /**
   * Modal open state
   */
  open?: boolean

  /**
   * Base modal width
   */
  baseWidth?: number

  /**
   * Expand container component on small devices
   */
  expandOnSmallDevices?: boolean

  /**
   * Modal content
   */
  children?:
    | React.ReactNode
    | ((props: { onClose?: () => void }) => React.ReactNode)

  /**
   * Position of the content
   */
  position?: 'center'

  /**
   * Disable close on backdrop click
   */
  disableBackdropClose?: boolean

  /**
   * Callback triggered on close
   */
  onClose?: () => void

  /**
   * Callback triggered when modal completely closed
   */
  onCloseEnd?: () => void

  /**
   * Backdrop component
   */
  BackdropComponent?: React.ComponentType<PassedBackdropProps>

  /**
   * Animation type
   */
  animationType?: 'fade' | 'slide-from-bottom'
}

export const InternalModal = ({
  className,
  title,
  open,
  baseWidth,
  children,
  expandOnSmallDevices,
  position = 'center',
  disableBackdropClose,
  onClose,
  onCloseEnd,
  BackdropComponent = Backdrop,
  animationType = 'fade',
}: InternalModalProps) => (
  <BackdropComponent
    open={open}
    zIndex={149}
    onClick={!disableBackdropClose ? onClose : undefined}
    onClosed={onCloseEnd}
  >
    <Inner
      className={className}
      position={position}
      open={open}
      expandOnSmallDevices={expandOnSmallDevices}
      baseWidth={baseWidth}
      animationType={animationType}
    >
      {title && <ModalHeader onClose={onClose}>{title}</ModalHeader>}
      <Content>
        {typeof children === 'function' ? children({ onClose }) : children}
      </Content>
    </Inner>
  </BackdropComponent>
)
